(() => {
  const dock = document.querySelector('[data-rexx-currency-dock]');
  if (!dock) return;
  const media = window.matchMedia('(max-width: 1023px)');
  let currency, originalParent, originalNext;
  function placeCurrency() {
    currency ||= document.querySelector('.doubly-float');
    if (!currency) return;
    if (!originalParent) { originalParent = currency.parentNode; originalNext = currency.nextSibling; }
    if (media.matches && currency.parentNode !== dock) dock.appendChild(currency);
    else if (!media.matches && currency.parentNode === dock) originalParent.insertBefore(currency, originalNext?.parentNode === originalParent ? originalNext : null);
  }
  document.querySelectorAll('[data-rexx-accessibility]').forEach(button => {
    button.addEventListener('click', event => {
      // The vendor closes its toolbar on clicks outside it. Keep this opening
      // click from reaching that document listener after the native toggle.
      event.stopPropagation();
      const trigger = document.getElementById('enable-toolbar-trigger');
      if (trigger) trigger.click();
    });
  });
  document.querySelectorAll('.rexx-builder-choice__bespoke a').forEach(link => {
    link.addEventListener('click', event => {
      if (event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(link.href);
    }, {capture:true});
  });
  placeCurrency();
  media.addEventListener('change', placeCurrency);
  const observer = new MutationObserver(placeCurrency);
  observer.observe(document.body, {childList:true, subtree:true});
  window.addEventListener('load', placeCurrency, {once:true});
  setTimeout(() => observer.disconnect(), 20000);
})();
